<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle> {{ $t("domains.add_domain") }}</DialogTitle>
            </DialogHeader>
            <form @submit.prevent="addDomain">
                <div class="grid gap-4 py-4">
                    <div class="grid w-full max-w-sm items-center gap-1.5">
                        <Label for="domain">{{ $t("domains.domain") }}</Label>
                        <Input
                            id="domain"
                            v-model="domain"
                            type="text"
                            placeholder="example.com"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <ZButton :disabled="loading" class="ml-4" type="submit">
                        {{ $t("domains.add_domain") }}
                    </ZButton>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import ZButton from "../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";

const open = ref(false);
const domain = ref("");

const loading = ref(false);

async function addDomain() {
    loading.value = true;
    open.value = false;

    router.post(
        route("app.domains.store"),
        {
            name: domain.value,
        },
        {
            onSuccess: () => {
                loading.value = false;
            },
        },
    );
}
</script>
